import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M9 15a6 6 0 1 0-6-6v6zm7.5-6A7.5 7.5 0 0 1 9 16.5H1.5V9a7.5 7.5 0 1 1 15 0",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M12 8.25H6v-1.5h6zm0 3H6v-1.5h6z",
		clipRule: "evenodd"
	})]
});
export default SvgMessage3;
